import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, Row, Col, message, Space, Flex } from "antd";
import { SearchOutlined, ReloadOutlined, FilterOutlined } from "@ant-design/icons";
import { masterDataService } from "../../../../api/enhancedApi";

const { Option } = Select;

/**
 * 邮箱分组过滤器组件
 * @param {Object} props
 * @param {Function} props.onSearch - 搜索回调函数
 * @param {Function} props.onReset - 重置回调函数
 */
const EmailGroupFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();
    const [availableTags, setAvailableTags] = useState([]);
    const [tagsLoading, setTagsLoading] = useState(false);

    // 加载可用标签
    useEffect(() => {
        loadAvailableTags();
    }, []);

    const loadAvailableTags = async () => {
        try {
            setTagsLoading(true);
            const response = await masterDataService.emailGroup.getAvailableTags();
            setAvailableTags(response.data?.tags || []);
        } catch (error) {
            console.error("加载标签失败:", error);
            message.error("加载标签失败");
        } finally {
            setTagsLoading(false);
        }
    };

    // 重置表单
    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    // 提交表单
    const handleFinish = (values) => {
        onSearch(values);
    };

    return (
        <Form form={form} layout="horizontal" onFinish={handleFinish}>
            <Row gutter={[16, 16]} align="middle">
                <Col xs={24} sm={12} md={6} lg={6}>
                    <Form.Item label="搜索" name="search" style={{ marginBottom: 0 }}>
                        <Input placeholder="分组名称或描述" allowClear prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />} />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={6} lg={6}>
                    <Form.Item label="标签" name="tags" style={{ marginBottom: 0 }}>
                        <Select mode="multiple" placeholder="请选择标签" allowClear loading={tagsLoading} showSearch filterOption={(input, option) => option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0} maxTagCount="responsive">
                            {availableTags.map((tag) => (
                                <Option key={tag} value={tag}>
                                    {tag}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4} lg={4}>
                    <Form.Item label="状态" name="is_active" style={{ marginBottom: 0 }}>
                        <Select placeholder="请选择状态" allowClear>
                            <Option value={true}>启用</Option>
                            <Option value={false}>停用</Option>
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={8}>
                    <Flex justify="flex-end" gap="small">
                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                            搜索
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset}>
                            重置
                        </Button>
                    </Flex>
                </Col>
            </Row>
        </Form>
    );
};

export default EmailGroupFilter;
